import authenticationFilter from './authentication-filter.ts';
import type {
    Authentication,
    AuthenticationConverter,
    AuthenticationManager,
    ServerAuthenticationEntryPoint,
    ServerAuthenticationFailureHandler
} from './types.ts';
import serverBearerTokenAuthenticationConverter from './oauth2/token-converter.ts';
import { serverAuthenticationEntryPointFailureHandler } from './entry-point-failure-handler.ts';
import bearerTokenServerAuthenticationEntryPoint from './oauth2/token-entry-point.ts';
import jwtAuthManager, { type Jwt } from './oauth2/jwt-auth-manager.ts';
import type { SecurityContext } from './security-context.ts';
import { AsyncLocalStorage } from 'node:async_hooks';
import type { ServerWebExchange } from '../../../types/web/server';
import type { WebFilter } from '../../web/server/types.ts';

export default function resourceServer(opts: {
    readonly storage: AsyncLocalStorage<{securityContext?: Promise<SecurityContext>}>,
    converter?: AuthenticationConverter,
    failureHandler?: ServerAuthenticationFailureHandler,
    entryPoint?: ServerAuthenticationEntryPoint,
    managerResolver?: (exchange: ServerWebExchange) => Promise<AuthenticationManager | undefined>,
    jwt?: {
        manager?: AuthenticationManager,
        decoder: (token: string) => Promise<Jwt>,
        authConverter?: (jwt: Jwt) => Promise<Authentication>
    }
}): WebFilter {
    const entryPoint = opts.entryPoint ?? bearerTokenServerAuthenticationEntryPoint({});
    const converter = opts?.converter ?? serverBearerTokenAuthenticationConverter({});
    const failureHandler = opts.failureHandler ?? serverAuthenticationEntryPointFailureHandler({entryPoint})
    if (opts.managerResolver!== undefined) {
        return authenticationFilter({
            storage: opts.storage,
            converter,
            failureHandler,
            managerResolver: opts.managerResolver,
        });
    }
    if (opts.jwt !== undefined) {

        const manager = opts.jwt.manager ?? jwtAuthManager(opts.jwt);
        return authenticationFilter({
            storage: opts.storage,
            converter,
            failureHandler,
            managerResolver: async (_exchange: ServerWebExchange) => {
                return manager;
            },
        });
    }
    throw new Error("Invalid resource server configuration: either managerResolver or jwt must be provided");
}
